var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.62471 5.7807L5.99971 2.2807L10.3747 5.7807C10.4773 5.86278 10.595 5.92385 10.7212 5.96043C10.8473 5.99701 10.9795 6.00838 11.11 5.9939C11.2406 5.97941 11.367 5.93935 11.4821 5.876C11.5972 5.81266 11.6986 5.72727 11.7807 5.6247C11.8628 5.52214 11.9239 5.40442 11.9604 5.27825C11.997 5.15209 12.0084 5.01995 11.9939 4.88939C11.9794 4.75884 11.9394 4.63241 11.876 4.51733C11.8127 4.40225 11.7273 4.30078 11.6247 4.2187L6.62471 0.218703C6.44735 0.0766995 6.22691 -0.000671667 5.99971 -0.000671678C5.7725 -0.000671689 5.55207 0.0766994 5.37471 0.218703L0.374708 4.2187C0.167573 4.38446 0.0347712 4.62572 0.00551527 4.88939C-0.0237406 5.15307 0.0529471 5.41757 0.218707 5.6247C0.300783 5.72727 0.402257 5.81266 0.517334 5.876C0.632411 5.93935 0.75884 5.97941 0.889399 5.9939C1.15307 6.02315 1.41757 5.94646 1.62471 5.7807Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.035ec99b8c26c04885ab1cac93794de8.svg";
export { ForwardRef as ReactComponent };